import { Button } from "@/components/ui/button";
import heroBg from "@/assets/hero-bg.jpg";

export const Hero = () => {
  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.9)), url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-smoke/20 to-void animate-smoke pointer-events-none" />
      
      <div className="relative z-10 container mx-auto px-4 text-center">
        <h1 className="text-6xl md:text-8xl font-black tracking-tighter mb-6 animate-flicker">
          <span className="text-blood-bright">This is not a book.</span>
          <br />
          <span className="text-foreground">This is your funeral.</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-steel mb-8 max-w-3xl mx-auto font-light tracking-wide">
          If you're ready to bury the weak, pathetic version of yourself that hits snooze, makes excuses, and dies a little more each day,  keep reading.
        </p>
        
        <p className="text-lg md:text-xl text-ash mb-12 max-w-2xl mx-auto italic">
          If you came here for comfort, motivation, or inspiration,  close this page. You won't find any. This is the execution manual for your old self.
        </p>
        
        <Button 
          onClick={scrollToCTA}
          size="lg"
          className="bg-blood-bright hover:bg-blood text-primary-foreground px-12 py-7 text-xl font-bold uppercase tracking-widest animate-pulse-glow transition-all hover:scale-105"
        >
          Start the Funeral,  Claim Your Copy
        </Button>
      </div>
    </section>
  );
};
